import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

const EmptyInvoicesComponent = () => {
  return (
    <div
      data-testid="invoices-list-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No invoices found</Typography>
      {/* The backend filters `type <> historical` out of this list, so a customer with only
          historical invoices lands here. Saying so stops it reading as a bug. */}
      <Typography variant="body2" css={tw`text-shades-500`}>
        Historical invoices are not listed here.
      </Typography>
    </div>
  )
}

export const EmptyInvoices = memo(EmptyInvoicesComponent)
